import React from 'react'
import AccessControl from '../../components/AccessControl';
import { Button, Col, Popconfirm, Row, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { findLiveTrackDevices } from './linkedIotDevice';
import RaiseTicketButton from './RaiseTicketButton';

export default function QuickActionBar({ data, authUser }) {
    const { asset } = data || {};

    // Same device rule for Live, BLE Live and Raise Ticket (see linkedIotDevice.js).
    const devices = findLiveTrackDevices(data);
    const { taggedDeviceAsset, bleTagAsset } = devices;

    return (<>
        {asset &&
            (<div style={{ justifyContent: "flex-end", textAlign: "right", marginBottom: '0px' }}>

                {taggedDeviceAsset &&
                    <AccessControl resource={'Asset'} permissionNeeded={'r'}
                        roles={authUser ? authUser.roles : []} render={(props) => {
                            return <>
                                <Tooltip placement="topLeft" title={"Asset Live Track"}>
                                    <Button className='gx-btn-blue' style={{ marginBottom: 0, marginRight: '3px' }}>
                                        <Link target='_blank'
                                            to={`/iot/device-details/${asset._id}/${taggedDeviceAsset.tagDeviceId}`}>Live</Link></Button>
                                </Tooltip>
                            </>
                        }} />}

                {bleTagAsset &&
                    <AccessControl resource={'Asset'} permissionNeeded={'r'}
                        roles={authUser ? authUser.roles : []} render={(props) => {
                            return <>
                                <Tooltip placement="topLeft" title={"BLE Beacon Live Track"}>
                                    <Button className='gx-btn-cyan' style={{ marginBottom: 0, marginRight: '3px' }}>
                                        <Link target='_blank' rel='noopener noreferrer'
                                            to={`/iot/ble-beacon-details/${asset._id}/${encodeURIComponent(bleTagAsset.bleTagId)}`}>BLE Live</Link></Button>
                                </Tooltip>
                            </>
                        }} />}

                {(taggedDeviceAsset || bleTagAsset) &&
                    <AccessControl resource={'Complaint'} permissionNeeded={'c'}
                        roles={authUser ? authUser.roles : []} render={() => (
                            <RaiseTicketButton data={data} authUser={authUser} devices={devices} />
                        )} />}

                <AccessControl resource={'Asset'} permissionNeeded={'u'}
                    roles={authUser ? authUser.roles : []} render={(props) => {
                        return <>
                            <Tooltip placement="topLeft" title={"Edit Asset"}>
                                <Button className='gx-btn-danger' style={{ marginBottom: 0, marginRight: '3px' }}>
                                    <Link target={'_blank'} to={`/asset/edit/${asset._id}`}>
                                        EDIT
                                    </Link>
                                </Button>
                            </Tooltip>
                        </>
                    }} />

                <AccessControl resource={'Complaint'} permissionNeeded={'c'}
                    roles={authUser ? authUser.roles : []} render={(props) => {
                        return <>
                            <Tooltip placement="topLeft" title={"Create Complaint for this Asset"}>
                                <Button className='gx-btn-orange' style={{ marginBottom: 0, marginRight: '3px' }}>
                                    <Link target={'_blank'} to={`/complaint/add/${asset._id}`}>
                                        Complaint
                                    </Link>
                                </Button>
                            </Tooltip>
                        </>
                    }} />

                <AccessControl resource={'Asset'} permissionNeeded={'u'}
                    roles={authUser ? authUser.roles : []} render={(props) => {
                        return <>
                            <Tooltip placement="topLeft" title={"Upload Document for this Asset"}>
                                <Button className='gx-btn-cyan' style={{ marginBottom: 0, marginRight: '0px' }}>
                                    <Link target={'_blank'} to={`/asset/upload/${asset._id}`}>
                                        Upload
                                    </Link>
                                </Button>
                            </Tooltip>
                        </>
                    }} />

            </div >)
        }</>
    )
}
